import React from 'react'
import { useParams } from 'react-router-dom'
import { Paper, Stack, Typography } from '@mui/material'
import { TrailMap } from '../../components/TrailMap/TrailMap.component'
import Loading from '../../components/Loading/Loading.component'
import { useQuery } from 'react-query'
import { TrailService } from '../../services/TrailService/TrailService'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs.component'
import DetailHeader from '../../components/Sections/DetailHeader.component'

export const TrailMapRoute: React.FC = () => {
  const { trailId } = useParams<{ trailId: string }>()
  const trailService = new TrailService()

  const {
    data: trail,
    isLoading,
    error,
  } = useQuery(['TrailService.get', { id: trailId }], () => trailService.get({ id: Number(trailId) }), {
    enabled: !!trailId,
    onError: (err) => {
      console.error('Error fetching trail:', err)
    },
  })

  if (isLoading) {
    return <Loading />
  }

  if (error || !trail || !trailId) {
    return (
      <Paper sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="center" alignItems="center" sx={{ py: 20 }}>
          <Typography variant="error">
            {trailId ? 'Trail not found or error loading trail data.' : 'No trail ID provided.'}
          </Typography>
        </Stack>
      </Paper>
    )
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Stack direction="row" sx={{ mb: 2 }}>
        <Breadcrumbs
          items={[
            { label: 'Trails', href: '/trails' },
            { label: trail.name, href: `/trails/${trail.id}` },
            { label: 'Map' },
          ]}
        />
      </Stack>
      <DetailHeader title={`Trail Map: ${trail.name}`} subtitle={trail.description || undefined} />
      <TrailMap trailId={Number(trailId)} />
    </Paper>
  )
}

export default TrailMapRoute
